import React from 'react'

import ArrowIcon from '../../../assets/icons/simple-arrow.svg'
import { GhostPost } from '../../../utils/types'
import styles from './GuideNavigator.module.scss'
import Link from '../../common/Link/Link'

type Props = {
  post: GhostPost
}

const STRINGS = {
  prev: 'Previous Chapter',
  next: 'Next Chapter',
}

const GuideNavigator: React.FC<Props> = ({ post }) => {
  const { footer_config } = post
  if (!footer_config?.previous && !footer_config?.next) {
    return null
  }
  return (
    <div className={styles.container}>
      {footer_config.previous ? (
        <div className={styles.prev}>
          <Link href={footer_config.previous.link}>
            <span>
              <ArrowIcon />
            </span>
            {STRINGS.prev}
          </Link>
          {footer_config.previous.title.split('\n').map((t) => (
            <p key={t}>{t}</p>
          ))}
        </div>
      ) : (
        <div />
      )}
      {footer_config.next ? (
        <div className={styles.next}>
          <Link href={footer_config.next.link}>
            {STRINGS.next}
            <span>
              <ArrowIcon />
            </span>
          </Link>
          {footer_config.next.title.split('\n').map((t) => (
            <p key={t}>{t}</p>
          ))}
        </div>
      ) : (
        <div />
      )}
    </div>
  )
}

export default GuideNavigator
